<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="编辑发票"
      width="1300"
      :open="open"
      @close="close"
      class="update-dialog"
      scrollable
    >
      <mu-form
        :model="editForm"
        label-position="left"
        label-width="80"
        ref="form"
        inline
        class="form"
      >
        <mu-form-item prop="customer" label="客户" class="full">
          <!-- <mu-text-field v-model="form.customer"></mu-text-field> -->
          <mu-auto-complete
            :data="customerList"
            :max-search-results="5"
            v-model="editForm.customerStr"
            open-on-focus
            :filter="customerFilter"
            @select="customerSelect"
            class="customer"
          >
            <template slot-scope="scope">
              <mu-list-item-content
                v-html="scope.highlight"
              ></mu-list-item-content>
            </template>
          </mu-auto-complete>
        </mu-form-item>

        <mu-form-item prop="buyer" label="公司名称" class="half">
          <mu-text-field v-model="editForm.buyer"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="buyerNum" label="税号" class="half">
          <mu-text-field v-model="editForm.buyerNum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="publishDate" label="开票日期" class="third">
          <mu-date-input container="dialog" v-model="editForm.publishDate"></mu-date-input>
        </mu-form-item>

        <mu-form-item prop="code" label="发票代码" class="third">
          <mu-text-field v-model="editForm.code"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="num" label="发票号码" class="third">
          <mu-text-field v-model="editForm.num"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="amount" label="金额" class="third">
          <mu-text-field v-model="editForm.amount"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="tax" label="税金" class="third">
          <mu-text-field v-model="editForm.tax"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="totalAmount" label="价税合计" class="third">
          <mu-text-field v-model="editForm.totalAmount"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="woods" label="商品" class="full">
          <!-- <mu-text-field v-model="form.woods"></mu-text-field> -->
          <mu-data-table
            :columns="columns"
            :data="editForm.goods"
            stripe
            class="table"
            :height="200"
          >
            <template slot-scope="scope">
              <td>
                <mu-text-field v-model="scope.row.name"></mu-text-field>
              </td>
              <td>
                <mu-text-field v-model="scope.row.type"></mu-text-field>
              </td>
              <td>
                <mu-text-field v-model="scope.row.unit"></mu-text-field>
              </td>
              <td>
                <mu-text-field v-model="scope.row.count"></mu-text-field>
              </td>
              <td>
                <mu-text-field v-model="scope.row.price"></mu-text-field>
              </td>
              <td>
                <mu-text-field v-model="scope.row.amount"></mu-text-field>
              </td>
              <td>
                <mu-text-field v-model="scope.row.taxRate"></mu-text-field>
              </td>
              <td>
                <mu-text-field v-model="scope.row.tax"></mu-text-field>
              </td>
            </template>
          </mu-data-table>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注" class="full">
          <mu-text-field v-model="editForm.remark"></mu-text-field>
        </mu-form-item>

        <mu-form-item label="发票照片" class="full">
          <Upload
            :api="api.invoice.picUpload"
            @complete="complete"
            :url="editForm.pic"
            @remove="picRemove"
          ></Upload>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import moment from 'moment'
import Upload from '@/components/fileUpload'
export default {
  components: { Upload },
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      api,
      customerList: [],
      editForm: {},
      columns: [
        {
          title: '名称',
          align: 'center',
          width: 220
        },
        {
          title: '规格',
          align: 'center'
        },
        {
          title: '单位',
          align: 'center'
        },
        {
          title: '数量',
          align: 'center'
        },
        {
          title: '单价',
          align: 'center'
        },
        {
          title: '金额',
          align: 'center'
        },
        {
          title: '税率',
          align: 'center'
        },
        {
          title: '税金',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    submit() {
      if (!this.editForm.customer) {
        this.$toast.error('请选择客户')
        return
      }
      backend(api.invoice.update, this.editForm).then((result) => {
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    complete(data) {
      if (data[1].words_result_num > 0) {
        const pic = data[0]
        const invoice = data[1].words_result
        this.editForm.data = invoice
        this.editForm.pic = pic.url
        this.editForm.buyer = invoice.PurchaserName
        this.editForm.buyerNum = invoice.PurchaserRegisterNum
        this.editForm.publishDate = moment(
          invoice.InvoiceDate,
          'YYYY年MM月DD日'
        ).toDate()
        this.editForm.amount = invoice.TotalAmount
        this.editForm.tax = invoice.TotalTax
        this.editForm.totalAmount = invoice.AmountInFiguers
        this.editForm.code = invoice.InvoiceCode
        this.editForm.num = invoice.InvoiceNum
        const goods = []
        invoice.CommodityName.forEach((item, index) => {
          const row = (index + 1).toString()
          goods.push({
            name: item.word,
            type: invoice.CommodityType.find((x) => x.row === row)
              ? invoice.CommodityType.find((x) => x.row === row).word
              : '',
            unit: invoice.CommodityUnit.find((x) => x.row === row)
              ? invoice.CommodityUnit.find((x) => x.row === row).word
              : '',
            count: invoice.CommodityNum.find((x) => x.row === row)
              ? invoice.CommodityNum.find((x) => x.row === row).word
              : '',
            price: invoice.CommodityPrice.find((x) => x.row === row)
              ? invoice.CommodityPrice.find((x) => x.row === row).word
              : '',
            amount: invoice.CommodityAmount.find((x) => x.row === row)
              ? invoice.CommodityAmount.find((x) => x.row === row).word
              : '',
            taxRate: invoice.CommodityTaxRate.find((x) => x.row === row)
              ? invoice.CommodityTaxRate.find((x) => x.row === row).word
              : '',
            tax: invoice.CommodityTax.find((x) => x.row === row)
              ? invoice.CommodityTax.find((x) => x.row === row).word
              : ''
          })
        })
        this.editForm.goods = goods
      } else {
        this.$toast.error('上传的不是发票或照片不清晰')
      }
    },
    getAllCustomer() {
      backend(api.user.getAll, { getAll: true, isCustomer: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.customerList = result.data.rows
          }
        }
      )
    },
    customerFilter(text, data, maxSearchResults) {
      return data
        .filter(
          (x) => x.realName.indexOf(text) > -1 || x.company.indexOf(text) > -1
        )
        .map((item) => {
          const value = item.company + ' - ' + item.realName
          return {
            value,
            item,
            highlight: `<span>${value.replace(
              text,
              '<span class="mu-secondary-text-color">' + text + '</span>'
            )}</span>`
          }
        })
    },
    customerSelect(value, item) {
      if (item) {
        this.editForm.customer = item
      } else {
        this.editForm.customer = null
      }
    },
    picRemove() {
      this.editForm.pic = ''
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
        this.editForm.customerStr = `${this.editForm.customer.company} - ${this.editForm.customer.realName}`
      }
    }
  },
  mounted() {
    this.getAllCustomer()
  }
}
</script>

<style lang="less" scoped>
.update-dialog {
  .form {
    .full {
      width: 100%;
    }
    .half {
      width: calc(50% - 16px);
    }
    .third {
      width: calc(33.33% - 16px);
    }
    .table {
      td {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/invoice/update.vue